import React, { useState, useEffect, useReducer } from "react";
import { useLocation, Navigate } from "react-router-dom";
import Select from "react-select";
import chroma from "chroma-js";
import { BeatLoader } from "react-spinners";
import prettier from "prettier";
import htmlParser from "prettier/parser-html";
import {
  Box,
  Button,
  Center,
  Card,
  Flex,
  Grid,
  GridItem,
  HStack,
  Icon,
  Image,
  Input,
  InputGroup,
  InputLeftAddon,
  List,
  ListIcon,
  ListItem,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Skeleton,
  Stack,
  Switch,
  Text,
  useColorMode,
  useColorModeValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
// Custom components
//import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import ClientModal from "views/Pages/Clients/components/ClientModal";
import { HSeparator } from "components/Separator/Separator.js";
// Date fns
import { format } from "date-fns";
// Icons
import { IoCodeSlash } from "react-icons/io5";
import {
  ChevronDownIcon,
  CloseIcon,
  LinkIcon,
  QuestionIcon,
  WarningIcon,
} from "@chakra-ui/icons";
import { SlPicture } from "react-icons/sl";
// React-syntax-highlighter
import SyntaxHighlighter from "react-syntax-highlighter";
import { solarizedDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { generateHtml } from "../HTML/html";
import { MdCheckCircle } from "react-icons/md";
// Reducer
const reducer = (state, action) => {
  if (action.type === "SWITCH_ACTIVE") {
    if (action.payload === "Visual") {
      const newState = {
        visual: true,
        links: false,
        code: false,
      };
      return newState;
    } else if (action.payload === "Links") {
      const newState = {
        visual: false,
        links: true,
        code: false,
      };
      return newState;
    } else if (action.payload === "Code") {
      const newState = {
        visual: false,
        links: false,
        code: true,
      };
      return newState;
    }
  }
  return state;
};

function New({ clientData, titleData, onClientUpdate }) {
  const toast = useToast();
  const prettier = require("prettier");
  const clients = clientData;
  const titles = titleData;
  const [client, setClient] = useState(null);
  const [newTitles, setNewTitles] = useState("empty");
  const newOption = newTitles === "empty" ? titles : newTitles;
  const [error, setError] = useState(false);
  const location = useLocation();
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const borderHeadColor = useColorModeValue("white", "transparent");
  const { colorMode } = useColorMode();
  const bgColor = useColorModeValue("white", "#4A5058");
  const bgCard = useColorModeValue(
    "gray.200",
    "linear-gradient(81.62deg, #343A40 2.25%, #212529 79.87%)"
  );

  const bgHead = useColorModeValue("hsla(0,0%,100%,.8)", "navy.800");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [footerNavItems, setFooterNavItems] = useState(3);
  const [offers, setOffers] = useState(5);
  // UTM Building
  const [source, setSource] = useState("dealeralchemist");
  const [medium, setMedium] = useState("email");
  const [name, setName] = useState(format(new Date(), "MMyy"));
  const [headerImageURL, setHeaderImageURL] = useState();
  const [navbarURLs, setNavbarURLs] = useState();
  const [offerImageURLs, setOfferImageURLs] = useState();
  const [defaultURLs, setDefaultURLs] = useState("");
  const [generatedURLs, setGeneratedURLs] = useState([]);
  const [footerURL, setFooterURL] = useState();
  const [inputValues, setInputValues] = useState(
    new Array(offers).fill("Please Paste a URL...")
  );
  const [footerNavInputValues, setFooterNavInputValues] = useState(
    new Array(offers).fill("Please Paste a URL...")
  );
  const [refreshNeeded, setRefreshNeeded] = useState(false);
  // html
  const [html, setHtml] = useState("");
  const formattedCode = prettier.format(html, {
    semi: false,
    parser: "html",
    plugins: [htmlParser],
  });
  // Switches
  const [switchFooterNav, setSwitchFooterNav] = useState(false);
  //Creatable Select
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState("empty");
  const [value, setValue] = useState();

  const [isLoaded, setIsLoaded] = useState(false);

  const [activeTemplate, setActiveTemplate] = useState("Links");

  const [state, dispatch] = useReducer(reducer, {
    visual: false,
    links: true,
    code: false,
  });

  useEffect(() => {
    client
      ? setHtml(
          generateHtml({
            footerNav: switchFooterNav,
            images: client.imageLinks,
            title: `${client.value}_email_${format(new Date(), "MMyy")}`,
            defaultURLs: generatedURLs,
            headerImageURL: headerImageURL,
            navbarURLs: navbarURLs,
            navbarImages: client?.navbarImages,
            navItems: client?.navbarImages.length,
            offers: offers,
            usedOffers: false,
            offerLinks: inputValues,
            offerImages: offerImageURLs,
            footerNavInputValues: footerNavInputValues,
            footerURL: footerURL ? footerURL : generatedURLs[0],
            additionalText: client.additionaltext,
          })
        )
      : setHtml("");
  }, [
    html,
    inputValues,
    switchFooterNav,
    footerNavInputValues,
    headerImageURL,
    navbarURLs,
    offers,
    error,
  ]);

  const generateCampaignURLs = (urls) => {
    const data = urls;
    if (!data) return;
    // This removes falsy values like '', undefined, null
    const updatedURLs = data.filter(Boolean).map((url) => {
      try {
        const campaignURL = new URL(url);
        campaignURL.searchParams.set("utm_source", source);
        campaignURL.searchParams.set("utm_medium", medium);
        campaignURL.searchParams.set("utm_campaign", name);

        // Convert the URL to a string and replace '+' with '%20'
        const campaignURLString = campaignURL.toString().replace(/\+/g, "%20");

        return campaignURLString;
      } catch (error) {
        console.error("Failed to construct URL:", url, error);
        toast({
          title: "Failed to construct URL.",
          description: url,
          status: "error",
          duration: 3000,
        });
        return null; // or skip this entry
      }
    });
    return updatedURLs;
  };

  const generateCampaignURL = (url, index) => {
    // Construct the campaign URL with UTM parameters
    const campaignURL = new URL(url);
    campaignURL.searchParams.set("utm_source", source);
    campaignURL.searchParams.set("utm_medium", medium);
    campaignURL.searchParams.set("utm_campaign", name);

    // Convert the URL to a string and replace '+' with '%20'
    const campaignURLString = campaignURL.toString().replace(/\+/g, "%20");

    // Update the state with the generated URL at the specified index
    setInputValues((prevURLs) => {
      const updatedURLs = [...prevURLs];
      updatedURLs[index] = campaignURLString; // Update specific index
      return updatedURLs;
    });
  };

  const handlePaste = (index) => (event) => {
    const pastedUrl = event.clipboardData.getData("text");
    console.log(pastedUrl);
    // Check if the pasted URL contains the client's website
    if (pastedUrl.includes(client?.clientwebsite)) {
      // Generate campaign URL if it does
      const campaignURL = new URL(pastedUrl);
      campaignURL.searchParams.set("utm_source", source);
      campaignURL.searchParams.set("utm_medium", medium);
      campaignURL.searchParams.set("utm_campaign", name);

      // Convert the URL to a string and replace '+' with '%20'
      const campaignURLString = campaignURL.toString().replace(/\+/g, "%20");

      // Update the specific input value
      setInputValues((prev) => {
        const updated = [...prev];
        updated[index] = campaignURLString; // Updated with campaign parameters
        return updated;
      });
    } else {
      // Simply set the pasted URL if it doesn't contain the client's website
      setInputValues((prev) => {
        const updated = [...prev];
        updated[index] = pastedUrl; // Set as is
        return updated;
      });
    }
  };

  const handleFooterPaste = () => (event) => {
    const pastedUrl = event.clipboardData.getData("text");

    // Check if the pasted URL contains the client's website
    if (pastedUrl.includes(client?.clientwebsite)) {
      // Generate campaign URL if it does
      const campaignURL = new URL(pastedUrl);
      campaignURL.searchParams.set("utm_source", source);
      campaignURL.searchParams.set("utm_medium", medium);
      campaignURL.searchParams.set("utm_campaign", name);

      // Convert the URL to a string and replace '+' with '%20'
      const campaignURLString = campaignURL.toString().replace(/\+/g, "%20");

      // Update the specific input value
      setFooterURL((prev) => campaignURLString);
    } else {
      // Simply set the pasted URL if it doesn't contain the client's website
      setFooterURL((prev) => pastedUrl);
    }
  };

  const handleFooterNavPaste = (index) => (event) => {
    const pastedUrl = event.clipboardData.getData("text");

    // Temporary URL generation before setting, assuming `source`, `medium`, and `name` are defined
    const campaignURL = new URL(pastedUrl);
    campaignURL.searchParams.set("utm_source", source);
    campaignURL.searchParams.set("utm_medium", medium);
    campaignURL.searchParams.set("utm_campaign", name);

    // Convert the URL to a string and replace '+' with '%20'
    const campaignURLString = campaignURL.toString().replace(/\+/g, "%20");

    // Update inputValues at the correct index
    setFooterNavInputValues((prev) => {
      const updated = [...prev];
      updated[index] = campaignURLString; // Replace with the new URL
      return updated;
    });
  };

  const handleFooterNavChange = () => {
    setSwitchFooterNav((prevState) => !prevState);
  };

  const colorStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: useColorModeValue("white", "#495057"),

      padding: "4px",
      borderRadius: "4px",
      border: "none",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor:
        isSelected && colorMode === "dark"
          ? "#3182ce"
          : isFocused
          ? "#3182ce"
          : undefined,
      color: useColorModeValue("gray.200", "white"),
    }),
    singleValue: (styles, { isFocused }) => {
      return {
        ...styles,
        color: useColorModeValue("white", "white"),
        backgroundColor:
          colorMode === "dark" ? "#3182ce" : isFocused ? "#d0dcfb" : "#3182ce",
        padding: "5px",
        borderRadius: "4px",
        fontSize: "85%",
        width: "fit-content",
      };
    },
    menu: (styles) => ({
      ...styles,
      backgroundColor: useColorModeValue("white", "#495057"),
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const handleCreate = () => {
    <Navigate
      to="/admin/clients/new-client/"
      state={{ from: location }}
      replace
    />;
  };

  const handleOnClick = (value) => {
    // Ensure 'value' is an array and has at least one element with a 'label' property
    if (value && value?.label) {
      setValue((prevState) => value); // Assuming 'setValue' updates state correctly
      // Extract and use the label from the first item of 'value'
      let clientLabel = value.label;
      let client = clients.filter((entry) =>
        Object.values(entry).some(
          (val) => typeof val === "string" && val.includes(clientLabel)
        )
      );
      if (client.length > 0) {
        let defUrls = [
          client?.[0]?.clientwebsite,
          client?.[0]?.navbar?.newvehicle,
          client?.[0]?.navbar?.usedvehicle,
          client?.[0]?.navbar?.additional,
          client?.[0]?.navbar?.finance,
        ];
        const response = generateCampaignURLs(defUrls);
        const headerLink = response?.[0];
        const navbarLinks = response.slice(1);
        setHeaderImageURL(headerLink);
        setNavbarURLs(navbarLinks);
        const offerCount =
          client[0].imageLinks?.length === 0
            ? 5
            : client[0].imageLinks?.length - 2;
        setOffers((prevOffers) => offerCount);
        const offerImages = client?.[0]?.imageLinks.slice(1, -1);
        setOfferImageURLs(offerImages);
        setInputValues(new Array(offerCount).fill("Please Paste a URL..."));
        if (client?.[0]?.specials) {
          generateCampaignURL(client?.[0]?.specials, 0);
        }
        setClient(client[0]);
        setGeneratedURLs(response);
        setIsLoaded(true);
      } else {
        toast({
          title: "Error:",
          description: `No client found with the label: ${clientLabel}`,
          status: "error",
          duration: 3000,
        });
      }
    } else {
      // Optionally, handle the error by resetting state or providing feedback to the user
      setInputValues((prevArray) => new Array(5).fill("Please Paste a URL..."));
      setValue();
      setOffers();
      setClient(null);
      setIsLoaded(false);
      setGeneratedURLs([]);
      setHtml("");
      setDefaultURLs("");
      setNavbarURLs(...[]);
      setFooterNavInputValues((prevArray) =>
        new Array(3).fill("Please Paste a URL...")
      );
    }
  };

  function downloadHtml(
    htmlString,
    filename = `${client?.value}_email_${format(new Date(), "MMyy")}.html`
  ) {
    // Create a blob of the html string
    const blob = new Blob([htmlString], { type: "text/html" });

    // Create an anchor element and set the URL to the blob
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename; // Set the file name for the download

    // Append the anchor to the document, trigger click, then remove
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  const refreshClientData = (_id) => {
    if (_id) {
      const updatedSelectedClient = clients.find((c) => c._id === _id);
      if (updatedSelectedClient) {
        setClient(updatedSelectedClient);
        const valueData = {
          value: updatedSelectedClient?.value,
          label: updatedSelectedClient?.label,
        };
        setValue((preValue) => valueData);
        if (updatedSelectedClient?.specials) {
          generateCampaignURL(updatedSelectedClient?.specials, 0);
        }
        let defUrls = [
          updatedSelectedClient?.clientwebsite,
          updatedSelectedClient?.navbar?.newvehicle,
          updatedSelectedClient?.navbar?.usedvehicle,
          updatedSelectedClient?.navbar?.additional,
          updatedSelectedClient?.navbar?.finance,
        ];
        const response = generateCampaignURLs(defUrls);
        const headerLink = response?.[0];
        const navbarLinks = response.slice(1);
        setHeaderImageURL((preValue) => headerLink);
        setNavbarURLs((preValue) => navbarLinks);
        setGeneratedURLs((preValue) => response);
        setIsLoaded(true);
      }
    }
  };

  useEffect(() => {
    if (refreshNeeded) {
      // Call refreshClientData with the ID you have
      refreshClientData(client?._id);
      setRefreshNeeded(false); // Reset the trigger
    }
  }, [refreshNeeded, clients, client]);

  const handleUpdateComplete = () => {
    setRefreshNeeded(true);
  };

  return (
    <Flex direction="column" overflowX="hidden">
      <Card
        bg={bgColor}
        mb={"md"}
        p={"15px"}
        borderRadius={"4px"}
        border="1px solid"
        borderColor={borderHeadColor}
      >
        <CardHeader pb={3}>
          <Text fontSize="lg" color={textColor} fontWeight="bold">
            Client Search
          </Text>
        </CardHeader>
        <CardBody pb={3}>
          <Flex direction="row" justify="center" w="100%">
            <Box p={"xs"} w={"100%"}>
              <Box bg={bgCard} p={"8px"} mb={"5px"} borderRadius={"4px"}>
                <Select
                  isClearable
                  isDisabled={isLoading}
                  isLoading={isLoading}
                  onChange={(newValue) => handleOnClick(newValue)}
                  options={newOption}
                  value={value}
                  styles={colorStyles}
                  placeholder="Search Clients..."
                />
              </Box>

              <Flex pt={3} justify={"space-between"} align="center">
                <Button
                  colorScheme="blue"
                  size="md"
                  loadingText="Loading"
                  spinnerPlacement="end"
                  isLoading={client === null ? true : false}
                  spinner={<BeatLoader size={8} color="white" />}
                  onClick={onOpen}
                >
                  View Client
                </Button>
                {client === null || client.imageLinks.length > 0 ? null : (
                  <Text color="red">
                    Client has no images. Please upload images before
                    proceeding.
                  </Text>
                )}

                <Button
                  colorScheme="green"
                  size="md"
                  loadingText="Loading"
                  spinnerPlacement="end"
                  isLoading={
                    client === null || client?.imageLinks.length === 0
                      ? true
                      : false
                  }
                  spinner={<BeatLoader size={8} color="white" />}
                  onClick={() => downloadHtml(formattedCode)}
                >
                  Download HTML
                </Button>
              </Flex>
            </Box>
          </Flex>
        </CardBody>
        <CardHeader pb={3}>
          <Text fontSize="lg" color={textColor} fontWeight="bold">
            Email Blast Settings
          </Text>
        </CardHeader>
        <CardBody>
          <Grid templateColumns="repeat(4, 1fr)" gap={6}>
            <GridItem w="100%">
              <InputGroup>
                <InputLeftAddon children="Header Nav" />
                <Input
                  type="number"
                  placeholder="default: 3"
                  readOnly
                  value={navbarURLs?.length ? navbarURLs.length : 3}
                  color={textColor}
                />
              </InputGroup>
            </GridItem>
            <GridItem w="100%">
              <InputGroup>
                <InputLeftAddon children="Offers" />
                <Input
                  type="number"
                  placeholder="default: 5"
                  readOnly
                  value={!offers ? setOffers(5) : offers}
                  color={textColor}
                />
              </InputGroup>
            </GridItem>
            <GridItem w="100%">
              {switchFooterNav === true ? (
                <InputGroup alignItems="center">
                  <InputLeftAddon children="Footer Nav" />
                  <Input
                    type="number"
                    placeholder="default: 3"
                    readOnly
                    color={textColor}
                  />
                </InputGroup>
              ) : null}
            </GridItem>
            <GridItem w="100%">
              <Stack alignItems="center">
                <Flex align="center" gap={3} pt={2}>
                  <Text fontSize="md" fontWeight="600">
                    Footer Nav?
                  </Text>
                  <Switch
                    colorScheme="blue"
                    isChecked={switchFooterNav}
                    onChange={() => handleFooterNavChange()}
                  />
                </Flex>
              </Stack>
            </GridItem>
          </Grid>
        </CardBody>
        <CardHeader p="12px 5px" mb="12px">
          <Text fontSize="lg" color={textColor} fontWeight="bold">
            UTM Tag Settings
          </Text>
        </CardHeader>
        <CardBody>
          <Stack direction="row" spacing={{ sm: "24px", lg: "30px" }}>
            <InputGroup>
              <InputLeftAddon children="Campaign Source:" />
              <Input
                type="number"
                placeholder="dealeralchemist"
                onChange={(e) =>
                  setSource(
                    e.target.value === ""
                      ? (prevState) => "dealeralchemist"
                      : (prevState) => e.target.value
                  )
                }
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon children="Campaign Medium:" />
              <Input
                type="number"
                placeholder="email"
                onChange={(e) =>
                  setMedium(
                    e.target.value === ""
                      ? (prevState) => "email"
                      : (prevState) => e.target.value
                  )
                }
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon children="Campaign Name:" />
              <Input
                type="number"
                placeholder={format(new Date(), "MMyy")}
                onChange={(e) =>
                  setName(
                    e.target.value === ""
                      ? (prevState) => format(new Date(), "MMyy")
                      : (prevState) => e.target.value
                  )
                }
              />
            </InputGroup>
          </Stack>
        </CardBody>
      </Card>
      <Box borderRadius="4px" pt={5} mx={{ "2xl": "300" }}>
        <Flex
          maxH="330px"
          justifyContent={"center"}
          align="center"
          backdropFilter="blur(21px)"
          boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
          border="1.5px solid"
          borderColor={borderHeadColor}
          bg={bgColor}
          p="24px"
          borderRadius="4px"
        >
          <Card
            bg={useColorModeValue("gray.200", "#6C757D")}
            p={"15px"}
            w={"100%"}
          >
            <HStack justify={"center"} w="auto" spacing={4}>
              <Button p="0px" bg="transparent" variant="no-effects">
                <Flex
                  align="center"
                  w={{ sm: "100%", md: "135px", lg: "135px" }}
                  bg={
                    state.visual
                      ? colorMode === "dark"
                        ? "#495057"
                        : "blue.500"
                      : null
                  }
                  borderRadius="4px"
                  justifyContent="center"
                  py="10px"
                  boxShadow={
                    state.visual ? "0px 2px 5.5px rgba(0, 0, 0, 0.06)" : null
                  }
                  cursor="pointer"
                  transition="all .5s ease"
                  onClick={() => (
                    dispatch({ type: "SWITCH_ACTIVE", payload: "Visual" }),
                    setActiveTemplate("Visual")
                  )}
                >
                  <Icon color={textColor} as={SlPicture} me="6px" />
                  <Text fontSize="xs" color={textColor} fontWeight="bold">
                    Visual
                  </Text>
                </Flex>
              </Button>
              <Button p="0px" bg="transparent" variant="no-effects">
                <Flex
                  align="center"
                  w={{ sm: "100%", md: "135px", lg: "135px" }}
                  borderRadius="4px"
                  justifyContent="center"
                  py="10px"
                  cursor="pointer"
                  boxShadow={
                    state.links ? "0px 2px 5.5px rgba(0, 0, 0, 0.06)" : null
                  }
                  bg={
                    state.links
                      ? colorMode === "dark"
                        ? "#495057"
                        : "blue.500"
                      : null
                  }
                  transition="all .5s ease"
                  onClick={() => (
                    dispatch({ type: "SWITCH_ACTIVE", payload: "Links" }),
                    setActiveTemplate("Links")
                  )}
                >
                  <Icon color={textColor} as={LinkIcon} me="6px" />
                  <Text fontSize="xs" color={textColor} fontWeight="bold">
                    Links
                  </Text>
                </Flex>
              </Button>
              <Button p="0px" bg="transparent" variant="no-effects">
                <Flex
                  align="center"
                  w={{ sm: "100%", md: "135px", lg: "135px" }}
                  borderRadius="4px"
                  justifyContent="center"
                  py="10px"
                  cursor="pointer"
                  boxShadow={
                    state.code ? "0px 2px 5.5px rgba(0, 0, 0, 0.06)" : null
                  }
                  bg={
                    state.code
                      ? colorMode === "dark"
                        ? "#495057"
                        : "blue.500"
                      : null
                  }
                  transition="all .5s ease"
                  onClick={() => (
                    dispatch({ type: "SWITCH_ACTIVE", payload: "Code" }),
                    setActiveTemplate("Code")
                  )}
                >
                  <Icon color={textColor} as={IoCodeSlash} me="6px" />
                  <Text fontSize="xs" color={textColor} fontWeight="bold">
                    Code
                  </Text>
                </Flex>
              </Button>
            </HStack>
          </Card>
        </Flex>
      </Box>
      {activeTemplate === "Links" ? (
        <Stack direction="column" pt={5} mx={{ "2xl": "300" }}>
          <Card
            bg={bgColor}
            p={"15px"}
            borderRadius={"4px"}
            border="1px solid"
            borderColor={borderHeadColor}
          >
            <CardHeader mb="5px">
              <Text fontSize="md" color={textColor} fontWeight="bold">
                Header Section
              </Text>
            </CardHeader>
            <CardBody>
              <InputGroup>
                <InputLeftAddon children="Link URL:" />
                <Input
                  type="url"
                  readOnly
                  value={
                    client && generatedURLs.length > 0
                      ? generatedURLs[0]
                      : "https://www.dealership.com/..."
                  }
                  color={textColor}
                />
              </InputGroup>
            </CardBody>
          </Card>
          <Card
            bg={bgColor}
            p={"15px"}
            borderRadius={"4px"}
            border="1px solid"
            borderColor={borderHeadColor}
          >
            <CardHeader mb="5px">
              <Text fontSize="md" color={textColor} fontWeight="bold">
                Navbar Section
              </Text>
            </CardHeader>
            <CardBody>
              {!error ? null : (
                <Center>
                  <Text color="red">
                    Client has 4 navbar links saved but only 3 navBar images.
                    Please update the client.
                  </Text>
                </Center>
              )}
              <Flex direction={"column"} gap={3}>
                {Array.from({ length: client?.navbarImages?.length }).map(
                  (e, i) => (
                    <InputGroup key={i} pl={1}>
                      <InputLeftAddon children="Link URL:" />
                      <Input
                        type="url"
                        readOnly
                        value={
                          client && generatedURLs.length > i
                            ? navbarURLs[i]
                            : "https://www.dealership.com/..."
                        }
                        color={textColor}
                      />
                    </InputGroup>
                  )
                )}
              </Flex>
            </CardBody>
          </Card>
          <Card
            bg={bgColor}
            p={"15px"}
            borderRadius={"4px"}
            border="1px solid"
            borderColor={borderHeadColor}
          >
            <CardHeader mb="20px">
              <Flex justify={"space-between"}>
                <Text fontSize="md" color={textColor} fontWeight="bold">
                  Offers Section
                </Text>
                <Button
                  rightIcon={<QuestionIcon color="blue.500" />}
                  variant="outline"
                  onClick={() =>
                    window.open(
                      "https://teams.dealeralchemist.com/landing/knowledgebase/articles/post/66cca48c0b6bf686f39ed3cc",
                      "_blank"
                    )
                  }
                >
                  Linking Guidelines
                </Button>
              </Flex>
            </CardHeader>
            <CardBody>
              {Array.from({ length: offers }).map((_, i) => (
                <Box key={i}>
                  <Flex minWidth="max-content" gap="2" align={"center"}>
                    <InputGroup pt="3px">
                      <InputLeftAddon children="Link URL:" />
                      <Input
                        type="url"
                        onPaste={handlePaste(i)}
                        value={
                          client && client.specials !== ""
                            ? inputValues[i]
                            : inputValues.length > 1
                            ? inputValues[i]
                            : "Please Paste a URL..."
                        }
                        onChange={() => {}} // This remains as an empty function for controlled component compliance
                        placeholder="Please Paste a URL..."
                        color={textColor}
                      />
                    </InputGroup>
                    <Menu>
                      <MenuButton
                        w="130px"
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                      >
                        Preview
                      </MenuButton>
                      <Portal>
                        <MenuList maxW="620px">
                          <MenuItem _hover={{}} _focus={{}}>
                            <Image src={offerImageURLs?.[i]} />
                          </MenuItem>
                        </MenuList>
                      </Portal>
                    </Menu>
                  </Flex>
                  <HSeparator my="14px" />
                </Box>
              ))}
            </CardBody>
          </Card>
          {switchFooterNav === true ? (
            <Card
              bg={bgColor}
              p={"15px"}
              borderRadius={"4px"}
              alignSelf={{ lg: "flex-start", "2xl": "stretch" }}
              border="1px solid"
              borderColor={borderHeadColor}
            >
              <CardHeader mb="20px">
                <Text fontSize="md" color={textColor} fontWeight="bold">
                  Footer Navbar Section
                </Text>
              </CardHeader>
              <CardBody>
                <Flex>
                  {Array.apply(null, { length: footerNavItems }).map((e, i) => (
                    <InputGroup key={i} pl={1}>
                      <InputLeftAddon children="Link URL:" />
                      <Input
                        type="url"
                        onPaste={handleFooterNavPaste(i)}
                        value={
                          footerNavInputValues[i]
                            ? footerNavInputValues[i]
                            : "Please Paste a URL..."
                        }
                        onChange={() => {}} // This remains as an empty function for controlled component compliance
                        placeholder="/new-inventory.htm..."
                        color={textColor}
                      />
                    </InputGroup>
                  ))}
                </Flex>
              </CardBody>
            </Card>
          ) : null}
          <Card
            bg={bgColor}
            p={"15px"}
            borderRadius={"4px"}
            border="1px solid"
            borderColor={borderHeadColor}
          >
            <CardHeader mb="5px">
              <Text fontSize="md" color={textColor} fontWeight="bold">
                Footer Section
              </Text>
            </CardHeader>
            <CardBody>
              <InputGroup>
                <InputLeftAddon children="Link URL:" />
                <Input
                  type="url"
                  onPaste={handleFooterPaste()}
                  value={
                    footerURL
                      ? footerURL
                      : generatedURLs.length > 0
                      ? generatedURLs[0]
                      : "https://www.dealership.com/..."
                  }
                  onChange={() => {}}
                  color={textColor}
                />
              </InputGroup>
            </CardBody>
          </Card>
        </Stack>
      ) : activeTemplate === "Visual" ? (
        <Stack direction="column" pt={5} mx={{ "2xl": "300" }}>
          <Card
            bg={bgColor}
            p={"15px"}
            borderRadius={"4px"}
            border="1px solid"
            borderColor={borderHeadColor}
          >
            {!error ? null : (
              <Center>
                <Text color="red">
                  Client has 4 navbar links saved but only 3 navBar images.
                  Please update the client.
                </Text>
              </Center>
            )}
            {(!isLoaded && client === null) ||
            client.imageLinks.length === 0 ? (
              <Flex direction="column">
                <Center>
                  <Skeleton
                    startColor={bgHead}
                    w="600px"
                    h="220px"
                    backdropFilter="blur(21px)"
                    boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
                    bg={bgHead}
                    borderRadius="5px"
                    p={1}
                  ></Skeleton>
                </Center>
                <Center>
                  <Flex p={1}>
                    <Box pr={1}>
                      <Skeleton
                        startColor={bgHead}
                        w="197px"
                        h="30px"
                        backdropFilter="blur(21px)"
                        boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
                        bg={bgHead}
                        borderRadius="5px"
                        pr={1}
                      />
                    </Box>
                    <Box pr={1}>
                      <Skeleton
                        startColor={bgHead}
                        w="197px"
                        h="30px"
                        backdropFilter="blur(21px)"
                        boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
                        bg={bgHead}
                        borderRadius="5px"
                        pr={1}
                      />
                    </Box>
                    <Box>
                      <Skeleton
                        startColor={bgHead}
                        w="197px"
                        h="30px"
                        backdropFilter="blur(21px)"
                        boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
                        bg={bgHead}
                        borderRadius="5px"
                        pr={1}
                      />
                    </Box>
                  </Flex>
                </Center>
                <Center>
                  <Skeleton
                    startColor={bgHead}
                    w="600px"
                    h="320px"
                    backdropFilter="blur(21px)"
                    boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
                    bg={bgHead}
                    borderRadius="5px"
                    p={1}
                  />
                </Center>
                <Center pt={1}>
                  <Skeleton
                    startColor={bgHead}
                    w="600px"
                    h="220px"
                    backdropFilter="blur(21px)"
                    boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
                    bg={bgHead}
                    borderRadius="5px"
                    p={1}
                  />
                </Center>
                <Center pt={1}>
                  <Skeleton
                    startColor={bgHead}
                    w="600px"
                    h="220px"
                    backdropFilter="blur(21px)"
                    boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
                    bg={bgHead}
                    borderRadius="5px"
                    p={1}
                  />
                </Center>
                <Center pt={1}>
                  <Skeleton
                    startColor={bgHead}
                    w="600px"
                    h="220px"
                    backdropFilter="blur(21px)"
                    boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
                    bg={bgHead}
                    borderRadius="5px"
                    p={1}
                  />
                </Center>
                <Center pt={1}>
                  <Skeleton
                    startColor={bgHead}
                    w="600px"
                    h="320px"
                    backdropFilter="blur(21px)"
                    boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
                    bg={bgHead}
                    borderRadius="5px"
                    p={1}
                  />
                </Center>
              </Flex>
            ) : (
              <Center pb={7}>
                <Flex direction="column" w="602px">
                  <Flex
                    direction="column"
                    w="602px"
                    border="1px"
                    borderColor="grey"
                    boxShadow="0px 17px 11px rgba(0, 0, 0, 0.1)"
                  >
                    <Image src={client?.imageLinks[0]} />
                    <Flex width="600px">
                      {Array.from({ length: client?.navbarImages?.length }).map(
                        (_, i) => (
                          <Image
                            key={i}
                            src={client?.navbarImages?.[i]}
                            flexShrink={1}
                            minW={0}
                          />
                        )
                      )}
                    </Flex>
                    {Array.from({ length: offers }).map((_, i) => (
                      <Image key={i} src={offerImageURLs?.[i]} />
                    ))}
                    <Image
                      src={client?.imageLinks[client?.imageLinks.length - 1]}
                    />
                  </Flex>
                  <Center>
                    <Text>{client?.additionaltext}</Text>
                  </Center>
                </Flex>
              </Center>
            )}
          </Card>
        </Stack>
      ) : activeTemplate === "Code" ? (
        <Stack direction="column" pt={5} mx={{ "2xl": "100" }}>
          <Card
            bg={bgColor}
            p={"15px"}
            borderRadius={"4px"}
            border="1px solid"
            borderColor={borderHeadColor}
          >
            <SyntaxHighlighter
              showLineNumbers
              language="htmlbars"
              style={solarizedDark}
              customStyle={{
                maxHeight: "40rem",
                fontSize: "1rem",
                padding: "1rem 1rem 1rem 0.25rem",
                overflowY: "scroll",
                margin: 0,
              }}
            >
              {formattedCode}
            </SyntaxHighlighter>
          </Card>
        </Stack>
      ) : null}
      {client ? (
        <ClientModal
          props={client}
          onOpen={onOpen}
          onClose={onClose}
          isOpen={isOpen}
          onUpdate={onClientUpdate}
          refresh={handleUpdateComplete}
        />
      ) : null}
    </Flex>
  );
}

export default New;
